import React = require("react");
import {Loader} from "../../../components/Utils/loader/Loader";
import "./EquipmentDashboard.scss";
import {CoffeeMachineDashboard, JSONCoffeeMachineTexts} from "./lavazza/CoffeeMachineDashboard";
import {defaultTheme} from "@vebox/etui-themes";
import { ThemeProvider } from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../../index";

const COFFEE_MACHINE_CATEGORY = "4a2e6ab0-172a-11e8-be9c-9418826ed820";

interface JSONEquipmentDashboardConfiguration {
    companyGuid: string;
    equipmentGuid: string;
    equipmentCategoryGuid: string;
    coffeeMachineTexts: JSONCoffeeMachineTexts;
    totalEquipmentCoffeeGroups: number;
    showSalesData: boolean;
}

interface EquipmentDashboardProps {
    equipmentId: number;
}

interface EquipmentDashboardState {
    configuration: JSONEquipmentDashboardConfiguration;
}

export class EquipmentDashboard extends React.Component<EquipmentDashboardProps, EquipmentDashboardState> {

    private static logEnabled: boolean = false;

    constructor(props) {
        super(props);
        this.state = {
            configuration: null,
        };
        this.retrieveConfiguration();
    }

    public render() {
        let content;
        if (this.state.configuration == null) {
            content = <Loader/>;
        }else{
            if (this.state.configuration.equipmentCategoryGuid === COFFEE_MACHINE_CATEGORY) {
                content = (
                    <CoffeeMachineDashboard
                        equipmentGuid={this.state.configuration.equipmentGuid}
                        texts={this.state.configuration.coffeeMachineTexts}
                        totalCoffeeGroups={this.state.configuration.totalEquipmentCoffeeGroups}
                        showSalesData={this.state.configuration.showSalesData}
                    />
                );
            } else {
                content = <Loader/>
            }
        }
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                {content}
            </ThemeProvider>
        );
    }

    private retrieveConfiguration(): void {
        this.log("Retrieving configuration");
        const url = "equipment/" + this.props.equipmentId + "/dashboard";
        Ajax.ajaxRequestForJson(
            {
                url,
                type: "GET",
                success: (response: JSONEquipmentDashboardConfiguration) => {
                    this.log("Success retrieving configuration");
                    this.log(response);
                    this.setState({configuration: response});
                },
            },
        );
    }

    // noinspection JSMethodCanBeStatic
    private log(message: any): void {
        if (EquipmentDashboard.logEnabled) {
            console.log(message);
        }
    }
}
